"use client";

import { Card } from "@/components/ui/card";

export interface McpTool {
  name: string;
  blurb: string;
  tag?: string;
}

export interface McpToolGroup {
  title: string;
  description: string;
  tools: McpTool[];
}

/** Grouped MCP tool catalog: mono tool names with one-line blurbs. */
export function ToolCatalog({ groups }: { groups: McpToolGroup[] }) {
  return (
    <div className="mt-10 grid gap-5 md:grid-cols-2">
      {groups.map((group) => (
        <Card key={group.title} className="border-[#1f2020] bg-[#101111] p-6">
          <h3 className="text-white">{group.title}</h3>
          <p className="mt-1.5 text-sm leading-relaxed text-white/60">{group.description}</p>
          <ul className="mt-4 flex flex-col gap-2.5">
            {group.tools.map((tool) => (
              <li key={tool.name} className="flex flex-wrap items-baseline gap-x-2.5 gap-y-0.5">
                <span className="shrink-0 rounded border border-[#2b2d2c] bg-[#0d0e0e] px-1.5 py-0.5 font-mono text-[11px] text-[#7fe7c8]">
                  {tool.name}
                </span>
                <span className="text-xs text-white/50">{tool.blurb}</span>
                {tool.tag ? (
                  <span className="shrink-0 rounded-full border border-[#3a3c3b] px-2 py-px text-[9px] uppercase tracking-wider text-[#8d918f]">
                    {tool.tag}
                  </span>
                ) : null}
              </li>
            ))}
          </ul>
        </Card>
      ))}
    </div>
  );
}
